export default __webpack_public_path__ + "static/media/haptiheart_demo_image.287dc050.png";